import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Home from './pages/home/Home';
import Cart from './pages/cart/Cart';
import Checkout from './pages/checkout/Checkout';
import { CartProvider } from './context/CartContext';
import Header from './components/Header';
import AdminAddProduct from "./pages/admin/AdminAddProduct";
import ProductView from "./pages/product/ProductView";

function App() {
    return (
        <CartProvider>
            <BrowserRouter>
                <Header />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/cart" element={<Cart />} />
                    <Route path="/checkout" element={<Checkout />} />
                    <Route path="/admin/add-product" element={<AdminAddProduct />} />
                    <Route path="/product/:id" element={<ProductView />} /> {/* <-- Add this line */}
                </Routes>
            </BrowserRouter>
        </CartProvider>
    );
}

export default App;
